 
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";  
import HotelBarchart from "../Agents/AgentComp/HotelBarchart";
import BusBarchart from "../Agents/AgentComp/BusBarchart";
import { useNavigate } from "react-router-dom";
import FlightBarchart from "../Agents/AgentComp/FlightBarchart";
import DistributorNavbar from "./DistributorComp/DistributorNavbar";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../component/Baseurl";


function AddAgentDistributor() {
  const navigate = useNavigate(); 
  
  useEffect(() => {
    // Retrieve stored agentid and agentemail from localStorage
    const distributor_id = localStorage.getItem("distributor_id");
    const distributor_email = localStorage.getItem("distributor_email");

    // Log the values
    console.log("Stored distributor_id:", distributor_id);
    console.log("Stored distributor_email:", distributor_email);

    // If agentid is not available, redirect to the login page
    if (!distributor_id || !distributor_email) {
      navigate("/login");  
    }
  }, [navigate]); 



  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",  // Add password field in state
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    companyName: "",
    cost_per_pin: ""
  });

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Retrieve distributor_id from localStorage
    const distributor_id = localStorage.getItem("distributor_id");

    // Add distributor_id to formData before submitting
    const updatedFormData = { ...formData, distributor_id };

    // Validation to check if all required fields are filled
    if (!updatedFormData.name || !updatedFormData.phone || !updatedFormData.email || !updatedFormData.address || !updatedFormData.city || !updatedFormData.state || !updatedFormData.country || !updatedFormData.pincode) {
      Swal.fire({
        title: "Error!",
        text: "Please fill in all required fields.",
        icon: "error",
        confirmButtonText: "OK"
      });
      return; // Stop form submission if any required field is empty
    }

    console.log("Sent Data:", updatedFormData);

    try {
      const response = await axios.post(`${baseurl}addAgents`, updatedFormData);
      console.log("Response:", response.data);

      if (response.data.message === "Agent added successfully, password setup email sent") {
        Swal.fire({
          title: "Success!",
          text: "Agent added successfully!",
          icon: "success",
          confirmButtonText: "OK"
        }).then(() => {
          // Reload the page after successful alert
          window.location.reload();
        });
        setShowModal(false); // Close the modal after success
      } else {
        Swal.fire({
          title: "Error!",
          text: "There was an error adding the agent. Please try again.",
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Please fill in all the fields..",
        icon: "error",
        confirmButtonText: "OK"
      });
    }
  };

  



  return (
    <>  
      <DistributorNavbar/>
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-start agenth1 pt-2 font4">
              <span>Welcome to Dashboard</span>
            </h1>

            
          </div>

          <div className="crdmain">
          <h2 className="title text-start">Create Distributor/Agent</h2>
<hr/>

            <div className="row g-2 mt-1 mb-4 justify-content-center ">
              <div className="col-md-12  p-2">
                <div className="ag1 p-2">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3 text-start">
                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Agent Name</label>
                      <input
                        type="text"
                        name="name"
                        className="input1"
                        placeholder="Enter name"
                        value={formData.name}
                        onChange={handleChange} required
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Phone</label>
                      <input
                        type="text"
                        name="phone"
                        className="input1"
                        placeholder="Enter phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Email</label>
                      <input
                        type="email"
                        name="email"
                        className="input1"
                        placeholder="Enter email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    {/* <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Password</label>
                      <input
                        type="password"
                        name="password"  // Add password field in form
                        className="input1"
                        placeholder="Enter password"
                        value={formData.password}
                        onChange={handleChange}
                      />
                    </div> */}
                    <div className="col-md-8">
                      <label className="text-dark mb-1 labelset2 font3">Address</label>
                      <input
                        type="text"
                        name="address"
                        className="input1"
                        placeholder="Enter address"
                        value={formData.address}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="text-dark mb-1 labelset2 font3">City</label>
                      <input
                        type="text"
                        name="city"
                        className="input1"
                        placeholder="Enter city"
                        value={formData.city}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="text-dark mb-1 labelset2 font3">State</label>
                      <input
                        type="text"
                        name="state"
                        className="input1"
                        placeholder="Enter state"
                        value={formData.state}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="text-dark mb-1 labelset2 font3">Country</label>
                      <input
                        type="text"
                        name="country"
                        className="input1"
                        placeholder="Enter country"
                        value={formData.country}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="text-dark mb-1 labelset2 font3">Pincode</label>
                      <input
                        type="text"
                        name="pincode"
                        className="input1"
                        placeholder="Enter pincode"
                        value={formData.pincode}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-8">
                      <label className="text-dark mb-1 labelset2 font3">Company/Business Name (Optional)</label>
                      <input
                        type="text"
                        name="companyName"
                        className="input1"
                        placeholder="Enter company or business name"
                        value={formData.companyName}
                        onChange={handleChange}
                      />
                    </div>


                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Cost Per Pin</label>
                      <input
                        type="text"
                        name="cost_per_pin"
                        className="input1"
                        placeholder="Enter Cost Per Pin"
                        value={formData.cost_per_pin}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="text-end mb-2">
                    <button type="submit" className="submit-btn mt-3">
                      Add Agent
                    </button>
                  </div>
                </form>
                </div>
              </div>

      
             
            </div>

 

          </div>
        </div>
      </div>
    </>
  );
}

export default AddAgentDistributor;
